module.exports = __webpack_public_path__ + "static/media/Patagonia-Gray-Better-Sweater-1-4-Zip-Jacket-for-Men-Lyst.412dfbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/Patagonia-Gray-Better-Sweater-1-4-Zip-Jacket-for-Men-Lyst.png
// module id = 257
// module chunks = 0